export const INDIRECT_TAX_TABLE_IDS = {
  TRANSACTIONS: 'transactions',
  FILINGS: 'filings',
  REGISTRATIONS: 'registrations',
  EXPOSURE: 'exposure',
} as const;
